// extracted by mini-css-extract-plugin
export default {"mainContainer":"CardsContainer_mainContainer__Fw0lU"};